// Add your JS customizations here
var xyz = jQuery(".typed-text");

var tl = new TimelineMax({
  repeat: -1,
  repeatDelay: 2,
});

tl.to(xyz, 1, {
  text: "Senior Product Designer",
})
  .to(
    xyz,
    1,
    {
      text: "Problem Solver",
    },
    "+=1.5"
  )

  .to(
    xyz,
    1,
    {
      text: "Visual Designer",
    },
    "+=1.5"
  );
// var cursor = jQuery(".ms-cursor"),
//   follower = jQuery(".ms-follower"),
//   cWidth = 8,
//   fWidth = 10,
//   delay = 10,
//   mouseX = 0,
//   mouseY = 0,
//   posX = 0,
//   posY = 0;

// TweenMax.to({}, 0.001, {
//   repeat: -1,
//   onRepeat: function () {
//     posX += (mouseX - posX) / delay;
//     posY += (mouseY - posY) / delay;

//     TweenMax.set(follower, {
//       css: {
//         left: posX - fWidth / 2,
//         top: posY - fWidth / 2,
//       },
//     });

//     TweenMax.set(cursor, {
//       css: {
//         left: mouseX - cWidth / 2,
//         top: mouseY - cWidth / 2,
//       },
//     });
//   },
// });

// jQuery(document).on("mousemove", function (e) {
//   mouseX = e.pageX;
//   mouseY = e.pageY;
// });

// jQuery("a").on({
//   mouseenter: function () {
//     cursor.addClass("is-active");
//     follower.addClass("is-active");

//     if (jQuery(this).hasClass("btn-secondary")) {
//       console.log("hi");
//       follower.addClass("is-difference");
//     }
//   },
//   mouseleave: function () {
//     cursor.removeClass("is-active");
//     follower.removeClass("is-active");
//     if (jQuery(this).hasClass("btn-secondary")) {
//       follower.removeClass("is-difference");
//     }
//   },
// });

function getMonthDifference(startDate, endDate) {
  return (
    endDate.getMonth() -
    startDate.getMonth() +
    12 * (endDate.getFullYear() - startDate.getFullYear())
  );
}
jQuery(".date.sf-date").text(
  getMonthDifference(new Date("2022-09-10"), new Date(Date.now())) + " Months"
);
jQuery(".date.dp-date").text(
  getMonthDifference(new Date("2021-12-15"), new Date("2022-09-10")) + " Months"
);
jQuery(".date.rt-date").text(
  getMonthDifference(new Date("2020-08-15"), new Date("2021-12-13")) + " Months"
);

jQuery(".date.fi-date").text(
  getMonthDifference(new Date("2014-10-15"), new Date("2022-05-10")) + " Months"
);
var offset = 0,
  diff = 0;
var has_next,
  not_next,
  $link = "";
// const body = document.body,
//   jsScroll = document.getElementsByClassName("js-scroll")[0],
//   height = jsScroll.getBoundingClientRect().height - 1,
//   speed = 0.05;

// var offset = 0;

// body.style.height = Math.floor(height) + "px";

// function smoothScroll() {
//   offset += (window.pageYOffset - offset) * speed;

//   var scroll = "translateY(-" + offset + "px) translateZ(0)";
//   jsScroll.style.transform = scroll;

//   var raf = requestAnimationFrame(smoothScroll);
// }
// smoothScroll();

jQuery(".ms-menu-toggler").on("click", function (e) {
  e.preventDefault();
  if (jQuery(".ms-menu-toggler").text() == "Close") {
    jQuery(".ms-menu-toggler").text("Menu");
    jQuery(".ms-main-nav").toggleClass("ms-show");
  } else {
    jQuery(".ms-menu-toggler").text("Close");
    jQuery(".ms-main-nav").toggleClass("ms-show");
  }
});

var positions = [],
  build_toc = function () {
    var output = "<p>Table of content</p><ul>",
      svg =
        '<svg viewBox="0 0 24 24"  height="24px" width="24px" y="0px" x="0px"><circle stroke-dashoffset="100" stroke-dasharray="100 100" r="11" cy="12" cx="12" stroke-width="2" fill="none"/></svg>';

    jQuery(".post-content")
      .find("h2")
      .each(function (i) {
        jQuery(this).attr("id", "title_" + i);

        output +=
          '<li><a href="#title_' +
          i +
          '" class="toc-title_' +
          i +
          '">' +
          svg +
          jQuery(this).text() +
          "</a></li>";
      });

    return output;
  },
  get_bottom_off_content = function () {
    var $content = jQuery(".post-content"),
      offset = $content.offset() + 50;

    return $content.outerHeight() + offset.top;
  },
  get_positions = function () {
    jQuery(".post-content")
      .find("h2")
      .each(function (i) {
        offset = jQuery(this).offset();
        positions["title_" + i] = offset.top;
      });
    return positions;
  },
  set_toc_reading = function () {
    var st = jQuery(document).scrollTop(),
      count = 0;
    for (var k in positions) {
      var n = parseInt(k.replace("title_", ""));
      (has_next = typeof positions["title_" + (n + 1)] !== "undefined"),
        (not_next =
          has_next && st < positions["title_" + (n + 1)] ? true : false),
        (diff = 0),
        ($link = jQuery(".toc-" + k));

      if (has_next) {
        diff =
          ((st - positions[k]) /
            (positions["title_" + (n + 1)] - positions[k])) *
          100;
      } else {
        diff =
          ((st - positions[k]) / (get_bottom_off_content() - positions[k])) *
          100;
      }

      $link.find("circle").attr("stroke-dashoffset", Math.round(100 - diff));

      if (st >= positions[k] && not_next && has_next) {
        jQuery(".toc-" + k).addClass("toc-reading");
      } else if (st >= positions[k] && !not_next && has_next) {
        jQuery(".toc-" + k).removeClass("toc-reading");
      } else if (st >= positions[k] && !not_next && !has_next) {
        jQuery(".toc-" + k).addClass("toc-reading");
      }

      if (st >= positions[k]) {
        jQuery(".toc-" + k).addClass("toc-already-read");
      } else {
        jQuery(".toc-" + k).removeClass("toc-already-read");
      }

      if (st < positions[k]) {
        jQuery(".toc-" + k).removeClass("toc-already-read toc-reading");
      }

      count++;
    }
  };

// build our table of content
jQuery(".table-of-contents").html(build_toc());

// first definition of positions
get_positions();

// on resize, re-calc positions
jQuery(window).on("resize", function () {
  get_positions();
});

jQuery(document).on("scroll", function () {
  set_toc_reading();
});
